// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { GridPickerTemplate } from "../../templates.js";
import { Control } from "./Control.js";

export let GridPicker = Control.extend({
    template: GridPickerTemplate,
    data: function ()
    {
        return {
            width: 129,
            height: 107,

            grid: null,

            maxRows: 5,
            maxColumns: 6,

            defaultRowsSelected: 1,
            defaultColumnsSelected: 1,

            rowsSelected: 1,
            columnsSelected: 1
        };
    }
});

GridPicker.prototype.getType = function () { return 'GridPicker'; };

GridPicker.prototype.oninit = function ()
{
    Control.prototype.oninit.apply(this);
    this.on('gridItemMouseMove', this.onGridItemMouseMove);
    this.on('gridItemMouseClick', this.onGridItemMouseClick);
    this.on('gridPickerMouseLeave', this.restoreDefaultSelection);

    this.observe('defaultRowsSelected defaultColumnsSelected', this.restoreDefaultSelection);
    this.observe('maxRows maxColumns', this.recreateGrid);
};

GridPicker.prototype.onGridItemMouseMove = function (event)
{
    this.set({
        rowsSelected: event.get('rowIdx') + 1,
        columnsSelected: event.get('columnIdx') + 1
    });

    return false;
};

GridPicker.prototype.onGridItemMouseClick = function (event)
{
    var context = event.context;
    this.fire(
        GridPicker.Events.Selected,
        this.get('rowsSelected'),
        this.get('columnsSelected'));

    return false;
};

GridPicker.prototype.restoreDefaultSelection = function ()
{
    this.set({
        rowsSelected: this.get('defaultRowsSelected'),
        columnsSelected: this.get('defaultColumnsSelected')
    });
};

GridPicker.prototype.recreateGrid = function ()
{
    var rows = this.get('maxRows');
    var columns = this.get('maxColumns');
    var grid = [];
    for (var row_i = 0; row_i < rows; row_i++)
    {
        var gridRow = [];
        grid.push(gridRow);
        for (var col_i = 0; col_i < columns; col_i++)
        {
            gridRow.push({
                rowIdx: row_i,
                columnIdx: col_i
            });
        }
    }
    this.set('grid', grid);
};

GridPicker.Events =
{
    Selected: 'selected'
};